export default "__VITE_ASSET__BoGgjknA__"